import { IDispatch } from "../context/authContext";

export function authReducer(state: any, action: IDispatch) {
    switch (action.type) {
        case "set_auth":
            return { ...state, ...action.payload };
    }
    throw Error("Action não encontrada: " + action.type);
}
